export const FEATURE_TOGGLE_SICK_LEAVE_HOURS =
  import.meta.env.VITE_FEATURE_TOGGLE_SICK_LEAVE_HOURS === '1'

export const FEATURE_TOGGLE_PENDING_VERIFICATION =
  import.meta.env.VITE_FEATURE_TOGGLE_PENDING_VERIFICATIONS === '1'

export const FEATURE_TOGGLE_CALENDAR_INTEGRATION =
  import.meta.env.VITE_FEATURE_TOGGLE_CALENDAR_FEATURE === '1'

export const FEATURE_TOGGLE_PAY_DATA =
  import.meta.env.VITE_FEATURE_TOGGLE_PAY_DATA === '1'

/**
 * We're using this feature toggle for when BND
 * sends us events through a web socket.
 */
export const FEATURE_TOGGLE_WEBSOCKETS =
  import.meta.env.VITE_FEATURE_TOGGLE_WEBSOCKETS === '1'

/**
 * We're using this feature toggle for when BND starts sending us keys
 * in the web sockets response rather than the whole object that needs to
 * be updated. With this approach, we'll do a GET request with the provided key
 * so we can take the data, no matter how big, that we're tracking through the
 * web socket.
 */
export const FEATURE_TOGGLE_WEBSOCKETS_LINKING =
  import.meta.env.VITE_FEATURE_TOGGLE_WEBSOCKETS_LINKING === '1'

export const FEATURE_TOGGLE_POST_SHIFT_REVIEW =
  import.meta.env.VITE_FEATURE_TOGGLE_POST_SHIFT_REVIEW === '1'

export const FEATURE_TOGGLE_SEGMENT =
  import.meta.env.VITE_FEATURE_TOGGLE_SEGMENT === '1'

export const FEATURE_TOGGLE_WORK_WITH_FRIENDS =
  import.meta.env.VITE_FEATURE_TOGGLE_WORK_WITH_FRIENDS === '1'

export const FEATURE_TOGGLE_ONBOARDING_WORKFLOWS =
  import.meta.env.VITE_FEATURE_TOGGLE_ONBOARDING_WORKFLOWS === '1'

export const FEATURE_TOGGLE_REDIRECT_TO_SPLIT_DOMAINS =
  import.meta.env.VITE_FEATURE_TOGGLE_REDIRECT_TO_SPLIT_DOMAINS === '1'

export const FEATURE_TOGGLE_PAYMENTS_SYSTEMS_REVAMP =
  import.meta.env.VITE_FEATURE_TOGGLE_PAYMENTS_SYSTEMS_REVAMP === '1'

export const FEATURE_TOGGLE_INVITE_UPSHIFTERS_REVAMP =
  import.meta.env.VITE_FEATURE_TOGGLE_INVITE_UPSHIFTERS_REVAMP === '1'

export const FEATURE_TOGGLE_LOCATION_SPECIFIC_BLOCKING =
  import.meta.env.VITE_FEATURE_TOGGLE_LOCATION_SPECIFIC_BLOCKING === '1'

export const FEATURE_TOGGLE_MULTIDAY_REVAMP =
  import.meta.env.VITE_FEATURE_TOGGLE_MULTIDAY_REVAMP === '1'

export const FEATURE_TOGGLE_RESTRICT_LAST_MINUTE_CANDIDATE_ADDITIONS_IN_THE_VMS =
  import.meta.env.VITE_RESTRICT_LAST_MINUTE_CANDIDATE_ADDITIONS_IN_THE_VMS ===
  '1'

export const FEATURE_TOGGLE_VMS_ONBOARDING_MANAGEMENT =
  import.meta.env.VITE_FEATURE_TOGGLE_VMS_ONBOARDING_MANAGEMENT === '1'

export const FEATURE_TOGGLE_ROSTERS =
  import.meta.env.VITE_FEATURE_TOGGLE_ROSTERS === '1'

export const FEATURE_TOGGLE_POST_SHIFT_REDESIGN =
  import.meta.env.VITE_FEATURE_TOGGLE_POST_SHIFT_REDESIGN === '1'

export const FEATURE_TOGGLE_LOCATION_VERIFICATION =
  import.meta.env.VITE_FEATURE_TOGGLE_LOCATION_VERIFICATION === '1'

export const FEATURE_TOGGLE_WAIT_LIST =
  import.meta.env.VITE_FEATURE_TOGGLE_WAIT_LIST === '1'

export const FEATURE_TOGGLE_CANDIDATE_REDESIGN =
  import.meta.env.VITE_FEATURE_TOGGLE_CANDIDATE_REDESIGN === '1'
